/* PinkyPillow native-bundle cart integration. Prices are charged by native Shopify variants. */
(function (scope) {
  'use strict';
  function same(a, b) { return JSON.stringify(a) === JSON.stringify(b); }
  function countKey(counts) { return counts.join(','); }
  function plan(counts, config) {
    if (counts.length !== 4 || counts.some(n => !Number.isSafeInteger(n) || n < 0)) throw Error('Invalid color quantities');
    const quantities = new Map();
    const add = (id, quantity) => { if (quantity) quantities.set(String(id), (quantities.get(String(id)) || 0) + quantity); };
    const remaining = [...counts];
    const take = size => {
      const selected = [0,0,0,0]; let left = size;
      for (let i = 0; i < 4 && left; i++) { const n = Math.min(remaining[i], left); selected[i] = n; remaining[i] -= n; left -= n; }
      if (left) throw Error('Invalid pack allocation');
      const bundle = config.bundles.find(b => countKey(b.counts) === countKey(selected));
      if (!bundle) throw Error('This color combination is unavailable');
      add(bundle.id, 1);
    };
    while (remaining.reduce((a,b) => a+b, 0) >= 4) take(4);
    if (remaining.reduce((a,b) => a+b, 0) === 3) take(3);
    if (remaining.reduce((a,b) => a+b, 0) === 2) take(2);
    remaining.forEach((n,i) => add(config.singles[i].id, n));
    return [...quantities].map(([id, quantity]) => ({id:Number(id),quantity})).sort((a,b)=>a.id-b.id);
  }
  function colorCounts(items, config) {
    const counts = [0,0,0,0];
    for (const item of items) {
      const id = String(item.variant_id || item.id);
      const single = config.singles.findIndex(v => String(v.id) === id);
      const bundle = config.bundles.find(v => String(v.id) === id);
      if (single < 0 && !bundle) continue;
      if (!Number.isSafeInteger(item.quantity) || item.quantity < 0) throw Error('Invalid cart quantity');
      if (item.selling_plan_allocation || Object.values(item.properties || {}).some(v=>v !== null && v !== '')) throw Error('Customized items need a separate cart review');
      if (item.parent_relationship) throw Error('Nested cart items need a separate cart review');
      if (single >= 0) counts[single] += item.quantity;
      else bundle.counts.forEach((n,i)=>{ counts[i] += n*item.quantity; });
    }
    return counts;
  }
  function eligible(item, config) {
    return config.singles.some(v=>String(v.id)===String(item.variant_id || item.id)) || config.bundles.some(v=>String(v.id)===String(item.variant_id || item.id));
  }
  function fingerprint(cart) {
    return JSON.stringify(cart.items.map(i=>({key:i.key,id:i.variant_id || i.id,quantity:i.quantity,properties:i.properties || {},sellingPlan:i.selling_plan_allocation?.selling_plan?.id || null})).sort((a,b)=>String(a.key).localeCompare(String(b.key))));
  }
  function updatesFor(cart, desired, config) {
    const updates = {};
    for (const item of cart.items) if (eligible(item, config)) updates[item.key] = 0;
    for (const item of desired) {
      const old = cart.items.find(i=>eligible(i,config) && String(i.variant_id || i.id)===String(item.id));
      updates[old?.key || String(item.id)] = item.quantity;
    }
    return updates;
  }
  function canonical(items, config) {
    const grouped = new Map();
    for (const item of items.filter(i=>eligible(i,config))) { const id=Number(item.variant_id || item.id); grouped.set(id,(grouped.get(id)||0)+item.quantity); }
    return [...grouped].map(([id,quantity])=>({id,quantity})).sort((a,b)=>a.id-b.id);
  }
  function validateResult(before, after, desired, counts, config) {
    if (!same(colorCounts(after.items,config),counts) || !same(canonical(after.items,config),desired)) throw Error('Bundle update could not be confirmed. Review your cart before checkout.');
    const unrelated=cart=>fingerprint({items:cart.items.filter(i=>!eligible(i,config))});
    if (unrelated(before)!==unrelated(after)) throw Error('Your cart changed during the update. Please review it before checkout.');
  }
  const core = {plan,colorCounts,updatesFor,canonical,validateResult,fingerprint};
  if (typeof module !== 'undefined' && module.exports) module.exports=core;
  if (!scope?.document) return;
  scope.PinkyPillowBundleCore=core;
  const node=scope.document.querySelector('[data-pp-bundle-cart-config]');
  if (!node) return;
  const config=JSON.parse(node.textContent);
  if (!config.enabled || config.currency!=='USD' || config.country!=='US') return;
  const root=scope.Shopify?.routes?.root || '/';
  let queue=Promise.resolve(), busy=false, catalog;
  const status=scope.document.createElement('div');
  status.className='pp-bundle-cart-status'; status.setAttribute('role','status'); status.setAttribute('aria-live','polite'); status.hidden=true;
  scope.document.body.append(status);
  function message(text,error=false) {status.textContent=text;status.hidden=!text;status.dataset.error=String(error);}
  async function readCart() {const r=await fetch(root+'cart.js',{headers:{Accept:'application/json'},credentials:'same-origin'});if(!r.ok)throw Error('Your cart could not be loaded. Please try again.');return r.json();}
  async function verifyCatalog() {
    if (!catalog) catalog=Promise.all([config.singleHandle,config.bundleHandle].map(async handle=>{const r=await fetch(root+'products/'+handle+'.js',{headers:{Accept:'application/json'},credentials:'same-origin'});if(!r.ok)throw Error('The bundle offer is not available yet.');return r.json();})).catch(error=>{catalog=null;throw error;});
    const [singles,bundles]=await catalog;
    for(const v of config.singles) if(!singles.variants.some(s=>String(s.id)===String(v.id)&&s.price===799))throw Error('Product prices changed. Refresh to see current offers.');
    for(const v of config.bundles) if(!bundles.variants.some(b=>String(b.id)===String(v.id)&&b.price===v.price))throw Error('Bundle prices changed. Refresh to see current offers.');
    return {singles,bundles};
  }
  async function reconcile(additions=[]) {
    const products=await verifyCatalog();
    for(let attempt=0;attempt<2;attempt++) {
      const before=await readCart();
      if(before.currency!=='USD')throw Error('Bundle pricing is available in USD.');
      const counts=colorCounts(before.items,config);
      colorCounts(additions.map(i=>({...i,key:String(i.id)})),config).forEach((n,i)=>counts[i]+=n);
      const desired=plan(counts,config);
      for(const item of desired) {const v=[...products.singles.variants,...products.bundles.variants].find(v=>String(v.id)===String(item.id));if(!v?.available)throw Error('One of the selected colors is unavailable. Please review your cart.');}
      if(!additions.length && same(canonical(before.items,config),desired))return before;
      const current=await readCart();
      if(fingerprint(before)!==fingerprint(current))continue;
      let after;
      try {
        const response=await fetch(root+'cart/update.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({updates:updatesFor(before,desired,config)})});
        after=await response.json();
        if(!response.ok)throw Error(typeof after.description==='string'?after.description:'Your bundle could not be updated.');
      } catch(error) {
        // A lost response can follow a successful update. Read back; never blindly retry a write.
        after=await readCart();
        try {validateResult(before,after,desired,counts,config);}catch {throw error;}
      }
      validateResult(before,after,desired,counts,config);
      scope.document.dispatchEvent(new CustomEvent('pp:bundle-cart-updated',{detail:{cart:after}}));
      scope.document.dispatchEvent(new CustomEvent('cart:build'));
      return after;
    }
    throw Error('Your cart changed while updating. Please review it and try again.');
  }
  function run(additions=[]) {
    const job=async()=>{
      busy=true;message('Applying your best bundle price…');
      try {const cart=await reconcile(additions);message('Bundle prices applied.');return cart;}
      catch(error){message(error.message+' No order has been placed.',true);throw error;}
      finally{busy=false;}
    };
    const action=()=>scope.navigator?.locks?scope.navigator.locks.request('pinkypillow-bundle-cart',job):job();
    const result=queue.then(action,action);queue=result.catch(()=>{});return result;
  }
  scope.PinkyPillowBundles={add:items=>run(items),normalize:()=>run(),get busy(){return busy;}};
  scope.document.addEventListener('submit',event=>{
    const form=event.target;
    if(!(form instanceof HTMLFormElement))return;
    if(/\/cart\/add(?:\.js)?$/.test(new URL(form.action,scope.location.href).pathname)) {
      const data=new FormData(form), id=Number(data.get('id')), quantity=Number(data.get('quantity')||1);
      if(!config.singles.some(v=>Number(v.id)===id))return;
      const properties={};for(const [k,v] of data)if(k.startsWith('properties['))properties[k.slice(11,-1)]=v;
      event.preventDefault();event.stopImmediatePropagation();
      run([{id,quantity,properties}]).then(()=>scope.location.assign(root+'cart')).catch(()=>{});
    } else if(event.submitter?.name==='checkout') {
      event.preventDefault();event.stopImmediatePropagation();
      run().then(()=>scope.location.assign(root+'checkout')).catch(()=>{});
    }
  },true);
  scope.document.addEventListener('click',event=>{
    const link=event.target.closest?.('a[href]');if(!link)return;
    const url=new URL(link.href,scope.location.href);
    if(url.origin===scope.location.origin&&/\/checkout\/?$/.test(url.pathname)) {
      event.preventDefault();event.stopImmediatePropagation();run().then(()=>scope.location.assign(url.href)).catch(()=>{});
    }
  },true);
  scope.document.addEventListener('cart:updated',()=>{if(!busy)run().catch(()=>{});});
})(typeof window!=='undefined'?window:null);

